import styled from 'styled-components'
import { tokens, primitives } from '../../../assets/tokens'

const { color } = tokens

export const PagerStyled = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-left: 16px;
  vertical-align: middle;
`

export const NavButton = styled.button`
  width: 40px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 1.5px solid ${primitives.neutral[300]};
  border-radius: 8px;
  background: ${color.background.default};
  color: ${primitives.neutral[800]};
  cursor: pointer;
  transition: background-color 0.2s ease, border-color 0.2s ease;

  :hover:not(:disabled) {
    border-color: ${primitives.neutral[400]};
    background: ${color.background.muted};
  }

  :disabled {
    cursor: default;
    color: ${primitives.neutral[400]};
    background: ${color.background.muted};
    border-color: ${primitives.neutral[200]};
  }

  :focus {
    outline: none;
  }
`
